import { UpdateTypeModel, UpdateTypeConnectionsModel, LookupModel } from '@core/services/api.service';


export class LoadUpdateTypeConnectionAction {
  static readonly type = '[Update types] Load Update Type connection';
}

export class LoadUpdateTypeConnectionSuccessAction {
  static readonly type = '[Update types] Load Update Type connection Success';

  constructor(public payload: { updateTypesConnections: UpdateTypeConnectionsModel[] }) { }
}

export class LoadUpdateTypeConnectionFailAction {
  static readonly type = '[Update types] Load Update Type connection Fail';
}


//-----------------

export class LoadUpdateTypesByParentIdAction {
  static readonly type = '[Update types] Load Update Type connection';

  constructor(public payload: { parentId: number }) { }
}

export class LoadUpdateTypesByParentIdSuccessAction {
  static readonly type = '[Update types] Load Update Type connection Success';

  constructor(public payload: { updateTypeConnection: UpdateTypeConnectionsModel[] }) { }
}

export class LoadUpdateTypesByParentIdFailAction {
  static readonly type = '[Update types] Load Update Type connection Fail';
}




//-------------------------------------------------
export class LoadUpdateTypesAction {
  static readonly type = '[Update types] Load update types';
}

export class LoadUpdateTypesSuccessAction {
  static readonly type = '[Update types] Load update types Success';

  constructor(public payload: { updateType: UpdateTypeModel[] }) { }
}

export class LoadUpdateTypesFailAction {
  static readonly type = '[Update Types] Load update types Fail';
}


//-------------------------------------------------
export class LoadFrequencyUpdateAction {
    static readonly type = '[Update types] Load frequency update types';
  }

  export class LoadFrequencyUpdateSuccessAction {
    static readonly type = '[Update types] Load frequency update types Success';

    constructor(public payload: { frequencyUpdateTypes: LookupModel[] }) { }
  }

  export class LoadFrequencyUpdateFailAction {
    static readonly type = '[Update Types] Load frequency update types Fail';
  }
